import { lazy } from "react";
const AboutUsPage = lazy(() => import("Pages/AboutUsPage"));
const HomePage = lazy(() => import("Pages/HomePage"));

export const routes = [
  {
    path: "/",
    component: <HomePage />,
  },
  {
    path: "/aboutUs",
    component: <AboutUsPage />,
  },
];
